import { PolicyCheck } from '@/features/auth/authorization';

export const AccountPolicies: Record<string, PolicyCheck> = {
  'account.view': ({ acl, user, meta }) => {
    return acl.settings.view;
  },
  'account.edit': ({ acl, user, meta }) => {
    return acl.settings.edit;
  },
};
